module.exports = __webpack_public_path__ + "img/8.a85b210b.png";